<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3 5L17 19M9 7H15C15.5523 7 16 7.44772 16 8V13.5C16 13.8148 16.1482 14.1111 16.4 14.3L20 17V7L16 10M15 17H5C4.44772 17 4 16.5523 4 16V8C4 7.44772 4.44772 7 5 7"
    />
  </svg>
</template>
